// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1PD6-","ranges":"BmiRanges_ranges__2NVhG"};